import { Box } from "@mui/material";
import { ComponentProps } from "../types";
import { CSSProperties, useContext, useMemo } from "react";
import DashboardComponent from "./DashboardComponent";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import DashboardPageContext from "../DashboardPageContext";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const style = useMemo(() => {
		const style = {
			display: "flex",
			flexDirection: (component.properties && component.properties["flexDirection"]) || "row",
			justifyContent: (component.properties && component.properties["justifyContent"]) || "flex-start",
			alignItems: (component.properties && component.properties["alignItems"]) || "stretch",
			gap: ((component.properties && component.properties["gap"]) || 0) + "px",
			flexWrap: (component.properties && component.properties["flexWrap"]) || "nowrap",
		} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		if (component.properties) {
			if (component.properties["width"]) style.width = component.properties["width"];
			if (component.properties["height"]) style.height = component.properties["height"];
			if (component.properties["padding"]) style.padding = component.properties["padding"];
			if (component.properties["backgroundColor"]) style.backgroundColor = component.properties["backgroundColor"];
			if (component.properties["flex"]) style.flex = component.properties["flex"];
		}
		return style;
	}, [component, exeMode]);
	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context]);
	const locatorArgs = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
	}, [component, exeMode]);
	const componentStyles = useMemo(() => {
		try {
			if (component.styles) {
				const styles = typeof component.styles === "string" ? evaluteScript(component.styles) : component.styles;
				if (styles != undefined) return styles as CSSProperties;
			}
		} catch (error) {
			console.error(error);
		}
		return {} as CSSProperties;
	}, [component]);
	return (
		<Box sx={{ ...style, ...componentStyles, ...(exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id ? { "& > div": { border: "1px dashed red" } } : {}) }} {...args} {...locatorArgs}>
			{component.childern && component.childern.map((c, i) => <DashboardComponent key={i} component={c} />)}
		</Box>
	);
}

export default Component;
